import BackgroundImage from './background.webp'

export { BackgroundImage }
